import React from "react";
import style from "../assets/css/page/Terms.module.css";
import LogoHeader from "../components/Header/LogoHeader";

function Terms() {
  return (
    <div className={style.container}>
      <div className={style.banner}>
        <div className={style.header}>
          <LogoHeader />
        </div>
        <div className={style.contTitle}>
          <h1 className={style.title}>Reglamento de la liga</h1>
          <p className={style.desc}>Actualizado Abr 25, 2022</p>
        </div>
      </div>
      <div className={style.terms}>
        <p>
          1. Se pagará una inscripción y una fianza, la cual es garantía de
          permanencia. Si el equipo termina el torneo, se le regresará la
          fianza.
        </p>
        <p>
          2. Para el mantenimiento del campo los equipos deberán aportar
          económicamente conforme el campo lo requiera, equipo que no cumpla
          será sancionado con una multa.
        </p>
        <p>
          3. Solo serán válidos los pagos en la jornada 1 y 2, de no pagar a
          tiempo el equipo será dado de baja.
        </p>
        <p>
          4. En la jornada 3 será la última fecha para registrar a sus jugadores
          y equipo en la plataforma, equipo que no cumpla será dado de baja.
        </p>
        <p>
          5. En la jornada 3 todos los jugadores tendrán que presentar la
          credencial que proporcione la liga para poder jugar, en caso de no
          hacerlo no podrán ser alineados.
        </p>
        <p>
          6. Toda protesta debe venir asentada en la cédula arbitral, de lo
          contrario no procede.
        </p>
        <p>7. En la jornada 8 será obligatorio el uniforme; playera y short.</p>
        <p>
          8. En la jornada 8 serán las altas y bajas para los equipos que
          quieran hacer algún cambio.
        </p>
        <p>
          9. Todos los equipos tendrán derecho a dos faltas en las juntas
          programadas, sin embargo tienen hasta el día siguiente para pagar su
          arbitraje (único día).
        </p>
        <p>
          10. Calificarán los primeros 8 equipos de la tabla general, la
          liguilla se jugará a dos partidos y la final solo 1 partido, en caso
          de empate en cuartos y semifinal el criterio será que pasa el que
          tiene mejor posición en la tabla y en la final son 3 penaltis, si
          persiste el empate, se va a muerte súbita hasta que salga el campeón.
        </p>
        <p>
          11. Las decisiones que tome la mesa no serán debatibles por los
          equipos.
        </p>
        <p>
          12. Las juntas semanales serán programadas los lunes a las 6 p.m.
          dando 15 minutos de tolerancia, equipo que no se presente deberá
          cubrir una cuota de 50 pesos y pierde por default.
        </p>
        <p>
          13. A los 3 partidos perdidos por default en la mesa se le dará de
          baja al equipo; así mismo si acumula 5 partidos perdidos por default
          entre la mesa y el campo.
        </p>
        <p>
          14. Los arbitrajes se pagarán en la junta, el equipo que gane por
          default en la mesa, pagará su arbitraje.
        </p>
        <p>
          15. El representante del equipo tiene la obligación de mantener en
          calma a sus jugadores, en caso de no hacerlo recibirá una sanción, si
          es un caso más grave, se considerará darle de baja al equipo.
        </p>
        <p>
          16. Todo jugador que agreda al cuerpo arbitral, jugador, directivo o
          aficionado será detenido por la policía en turno, y será expulsado del
          torneo.
        </p>
        <p>
          17. Los pitidos del árbitro serán a la hora en punto, el segundo 5
          minutos después, el tercero a los 10 minutos, dando por finalizado el
          partido.
        </p>
        <p>
          18. El árbitro puede expulsar al representante del equipo a cualquier
          jugador que esté en la banca, si alguno de estos está alebrestando a
          los que están dentro, contra el árbitro o contra el equipo contrario.
        </p>
        <p>
          19. Solo jugadores y representante estarán en el área de banca, si hay
          personas que no son del equipo, favor de retirarlos, en caso de no
          hacerlo el partido no se llevará a cabo, acá entra el apoyo de los
          equipos y el cuerpo arbitral.
        </p>
        <p>
          20. La cantidad de juegos que tienen que cumplir los jugadores es del
          50% + 1 para que tenga derecho a jugar la liguilla, si alguno de estos
          juegos lo gana por default en la mesa, este partido será contado a
          favor de todo el equipo si lo pierde se contará en contra.
        </p>
        <p>
          21. Para que los equipos sepan cuantos juegos llevan sus integrantes
          así como goles, amonestaciones o expulsiones el árbitro debe entregar
          una copia de la cédula a cada equipo debidamente firmado por los
          capitanes y por el árbitro; capitán que no firme o altere la cédula
          será suspendido 2 partidos y pagará una multa de 100 pesos.
        </p>
        <p>
          22. Un jugador que tenga 3 tarjetas amarillas será suspendido 1
          partido, jugador que tenga dos expulsiones será suspendido 1 partido,
          y dependiendo de la gravedad recibirá una sanción extra por parte de
          la mesa.
        </p>
        <p>
          23. El representante del equipo es el único que tiene voz y voto en
          las juntas, si no llega él a la junta, podrá enviar a otra persona
          solo para pagar su arbitraje y recibir información.
        </p>
        <p>
          24. Si en dado caso ocurre algún incidente el cual no venga
          especificado en el reglamento, se resolverá en la junta por la mesa
          directiva y cualquier decisión no será debatible por los equipos.
        </p>
        <p>
          25. Todos los equipos deberán presentar 1 balón número 4
          obligatoriamente y en buenas condiciones (se le dará al equipo la
          oportunidad de presentar su balón antes del primer tiempo, de lo
          contrario perderá el partido por default).
        </p>
        <p>
          26. Durante el partido podrán realizar los cambios que requiera el
          equipo; para que el partido no se detenga el representante tendrá que
          llamar a la banda al jugador que será suplido para que ingrese el
          jugador que lo sustituya.
        </p>
        <p>
          27. Todos los equipos deberán presentar obligatoriamente: short,
          playera, medias, espinilleras tenis adecuados (no “tacos” de fútbol).
        </p>
        <p>
          28. No se le permitirá jugar a nadie con short, bermuda, lycra,
          peinetas, aretes u objetos que pongan en riesgo la integridad física
          de los jugadores.
        </p>
        <p>
          29. Cada partido tendrá una duración de 25 minutos cada tiempo y un
          descanso de 5 minutos.
        </p>
        <p>
          30. Cada equipo tiene derecho de pedir 1 tiempo fuera de 1 minuto por
          cada tiempo (el tiempo fuera va incluido en el tiempo reglamentario).
        </p>
        <p>
          31. El árbitro podrá solicitar un tiempo fuera si así lo requiere.
        </p>
        <p>
          32. El único que puede ingresar al campo al pedir el tiempo fuera es
          el representante.
        </p>
        <p>
          33. Se marcará un gol cuando el balón haya pasado la línea de meta
          ubicada en la portería ya sea por tierra o por aire.
        </p>
        <p>
          34. no es válido un gol dentro del área con los pies; el único gol
          valido con los pies es el penal, el gol con la cabeza dentro del área
          es válido.
        </p>
        <p>
          35. Si un jugador chuta a gol y se le pega a su compañero que está
          dentro del área y entra, el gol será anulado, si le pega al
          contrincante y entra será autogol.
        </p>
        <p>
          36. En la marcación de una falta, el equipo defensor deberá estar a 5
          metros del balón hasta que esté en juego nuevamente, si alguien se
          adelanta será amonestado.
        </p>
        <p>
          37. En el tiro penal, el guardameta deberá permanecer sobre la línea
          de meta hasta que el balón sea tocado por el cobrador, de lo contrario
          se repite la jugada.
        </p>
        <p>
          38. Se marcará un tiro penal en contra del equipo que llegue a las
          primeras 5 faltas durante el partido y posteriormente por cada 3
          faltas.
        </p>
        <p>
          39. se marcará un penal en contra del equipo que cometa 1 falta dentro
          del área del portero, esa falta no se tomará en cuenta en las faltas
          acumuladas.
        </p>
        <p>40. solo el portero podrá barrer dentro de su área.</p>
        <p>41. todas las barridas son faltas acumuladas.</p>
        <p>
          42. el jugador tendrá solo 5 segundos para realizar el saque de banda
          o saque de esquina de lo contrario se le concederá al otro equipo.
        </p>
        <p>43. No es válido el gol directamente de un saque de banda.</p>
        <p>
          44. El jugador que haga el saque de banda o de esquina no podrá tocar
          el balón hasta que lo toque otro jugador.
        </p>
        <p>
          45. El portero podrá lanzar o chutar el balón desde cualquier punto de
          su área, sin que rebase la media cancha, de lo contrario el saque será
          para el otro equipo (si este incidente ocurre 3 veces será considerada
          una falta acumulable.)
        </p>
        <p>
          46. Si el portero lanza o chuta el balón sin que rebase la media
          cancha y este cae a gol, será válido.
        </p>
        <p>
          47. El portero tendrá 5 segundos para realizar su saque, de lo
          contrario se le marcará una falta y un tiro libre.
        </p>
        <p>
          48. En el momento en el que el portero pone el balón en el césped ya
          está en juego, al menos que se vaya a cobrar una falta o el árbitro
          indique alguna sanción.
        </p>
        <p>
          49. El portero no podrá jugar el balón con la mano cuando ya lo haya
          puesto en el piso, de lo contrario se le marcará una falta.
        </p>
        <p>
          50. El portero no debe agarrar el balón con las manos cuando este
          venga de su compañero, a menos que sea con la cabeza o con alguna
          parte del cuerpo menos con los pies y las manos, de lo contrario se
          marcará una falta acumulable.
        </p>
        <p>51. El jugador que diga “déjala” se le marcará como una falta.</p>
        <p>
          52. Un jugador que sea expulsado por dos tarjetas amarillas será
          suspendido un partido.
        </p>
        <p>53. cualquier mano será marcada como falta y será acumulable.</p>
        <p>
          54. Por juego brusco de algún jugador será castigado con dos partidos.
        </p>
        <p>
          55. Por conducta violenta de algún jugador será castigado con 5
          partidos *al igual si tira una patada, puñetazo o un cabezazo a un
          jugador contrario.
        </p>
        <p>
          56. Por conducta violenta será expulsado de la liga al dar una patada
          un puñetazo o un cabezazo a un jugador contrario.
        </p>
        <p>
          57. escupir a un adversario o cualquier otra persona se sanciona con
          una suspensión en los próximos 2 partidos.
        </p>
        <p>
          58. emplear lenguaje o gesticula de manera ofensiva o grosera u
          obscena; dos partidos de suspensión.
        </p>
        <p>
          59. Dirigirse al árbitro de manera grosera o altanera; 3 partidos de
          suspensión.
        </p>
        <p>
          60. El jugador que agrede a un árbitro será expulsado de la liga y el
          equipo tendrá la obligación de cubrir los daños.
        </p>
        <p>61. el equipo que inicie una riña, será expulsado de la liga.</p>
        <p>62. invasión del campo, pierde el partido y multa de 200 pesos</p>
        <p>
          63. cuando se amonesta a un jugador sale 2 minutos, y si cae el gol en
          contra antes, puede ingresar.
        </p>
        <p>
          64. Cuando se amonesta a un jugador 2 veces automáticamente queda
          expulsado, después de 5 minutos puede ingresar otro jugador.
        </p>
        <p>
          65. Cuando se expulsa un jugador con tarjeta roja directa, ya no
          ingresa nadie para sustituirlo.
        </p>
        <p>
          66. Para que un partido de inicio, el mínimo de jugadores debe ser de
          5 y si termina el primer tiempo el equipo ya no podrá ingresar a otro
          jugador, a menos que sea por cambio.
        </p>
        <p>
          67. El equipo que se quede con 4 jugadores por expulsión o lesión el
          partido finalizará y el equipo con 4 jugadores perderá el encuentro.
        </p>
        <p>
          68. Meter cuerpo cerca de la banda es falta acumulativa y se amonesta
          al jugador y sale dos minutos fuera.
        </p>
        <p>
          69. todo jugador o representante que sea reportado pòr el comité
          deportivo, policia, cuerpo arbitral, representantes de equipos, dando
          mal uso de las instalaciones deportivas será sancionado por la mesa
        </p>
        <p>
          70. Si algún jugador ingresa al campo y juega con tacos será expulsado
          tres partidos.
        </p>
        <p>
          71. Si algún representante jugador o cuerpo arbitral detecta a algún
          jugador con aliento alcohólico o en estado inapropiado el árbitro
          detendrá el partido y retirará del campoa dicho jugador el cual será
          sancionado por la mesa directiva y el equipo puede ingresar a otro
          jugador, si el suspendido marcó gol, se le anula a él y al equipo al
          que pertenece.
        </p>
        <p>
          72. El jugador que sea expulsado en alguna de las categorías en la
          cual se realizan en las instalaciones del deportivo 20 de noviembre
          pagará su sanción total en esa categoría y la mitad en las otras
          categorías. (ejemplo/ si en la categoría libre se expulsa 2 partidos y
          juega en la laboral, en esa categoría será expulsado 1 partido.) si la
          sanción es expulsión de la liga, queda expulsado de los demás torneos.
        </p>
      </div>
    </div>
  );
}

export default Terms;
